export default {
  EUR: 'EUR',
  GBP: 'GBP',
  USD: 'USD',
  SEK: 'SEK',
  JPY: 'JPY',
}
